// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import '@/plugins/element-ui'
import '@/plugins/base-component'
import router from './router'
import store from '@/store'
import '@/base'
import Modules from './modules'
// import {addScript} from '@/commons/utils'
import loadResource from '@front-end/utils/lib/loadResource'
// import hls from 'videojs-contrib-hls'
import './statics'

// import * as fundebug from 'fundebug-javascript'
// import FundebugVue from 'fundebug-vue'
// require('fundebug-revideo')
// import * as Sentry from '@sentry/vue'
// import { BrowserTracing } from '@sentry/tracing'

window._babelPolyfill = false
let vm = null
// Vue.use(hls)
export const BUS = new Vue()
Vue.prototype.$bus = BUS

// console.log('NODE_ENV', process.env.NODE_ENV)
// if (process.env.NODE_ENV !== 'development') {
//   fundebug.releasestage = process.env.NODE_ENV
//   fundebug.apikey = '28282efb0ac765e5f3b5891a0bd6cd3643780e5c41f57c6431c3f3643003ab3d'
//   new FundebugVue(fundebug).installVueErrorHandler(Vue) // Vue 2.x
// }
// if (process.env.NODE_ENV !== 'development') {
//   Sentry.init({
//     environment: process.env.NODE_ENV,
//     Vue,
//     dsn: 'https://0adce2c5676242449d2e5346fdb30a06@o414797.ingest.sentry.io/4504806237667328',
//   // This sets the sample rate to be 10%. You may want this to be 100% while
//   // in development and sample at a lower rate in production
//     replaysSessionSampleRate: 0.1,

//   // If the entire session is not sampled, use the below sample rate to sample
//   // sessions when an error occurs.
//     replaysOnErrorSampleRate: 1.0,
//     integrations: [
//       new BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//         tracePropagationTargets: ['localhost', 'local.jin10.com', /^\//]
//       }),
//       new Sentry.Replay({
//         maskAllText: false
//       })
//     ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//     logErrors: true,
//     ignoreErrors: ['ResizeObserver loop limit exceeded']

//   })
// }

const init = () => {
  Vue.config.productionTip = false
  Vue.use(Modules)
  window.JIN10_APP.VueComponents(Vue)
  vm = new Vue({
    router,
    store
  }).$mount('#J_tv')
  vm.$router.beforeEach((to, from, next) => {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    vm.$loadingBar.start()
    next()
  })
  vm.$router.afterEach(() => {
    vm.$loadingBar.finish()
  })
}
const cdnBase = '//cdn.jin10.com/components/v1'
loadResource([
  `${cdnBase}/new-layout-common/index.js?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/new-layout-common/index.css?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/header-new/index.js?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/header-new/index.css?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/footer-new/index.js?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/footer-new/index.css?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/glass-btn/index.js?v=${window.FE_COMP_TIME_VER}`,
  `${cdnBase}/glass-btn/index.css?v=${window.FE_COMP_TIME_VER}`
], { returnPromise: true }).then(() => {
  function registerAsyncComponent (tagName, windowKey) {
    Vue.component(tagName, () => new Promise((resolve) => {
      function tryResolve () {
        const comp = window[windowKey]
        if (comp) {
          resolve(comp)
        } else {
          setTimeout(tryResolve, 100)
        }
      }
      tryResolve()
    }))
  }
  const registerDirectives = () => {
    const layoutCommon = window['new-layout-commonComponent']
    console.log('layoutCommon', layoutCommon)
    if (layoutCommon && layoutCommon.glassDirective) {
      Vue.directive('glass', layoutCommon.glassDirective)
      Vue.directive('dark-mask', layoutCommon.darkMaskDirective)
    } else {
      setTimeout(registerDirectives, 100)
    }
  }
  registerDirectives()
  registerAsyncComponent('glass-btn', 'glass-btnComponent')
  registerAsyncComponent('footer-new', 'footer-newComponent')
  registerAsyncComponent('header-new', 'header-newComponent')
  if (process.env.NODE_ENV === 'development') {
    window.Vue = Vue
    loadResource([
      '//cdn.jin10.com/assets/js/vue-components/js/index.js'
    ], { returnPromise: true }).then(() => {
      init()
    })
  } else {
    init()
  }
})

const privateType = '303ccae79fc4661d'
const playState = (options) => {
  // console.log(options)
  let type = vm.$route.meta.type || window._videoType
  if (type !== privateType && options.type === privateType) {
    return false
  }
  if (!type && options.type === 'tradingNew') {
    return false
  }
  if (type && type !== options.type) {
    return false
  }
  store.dispatch('setLiveUrl', options.url)
  store.dispatch('setLiveType', options.type)
  store.dispatch('setEmcee', options.emcee)
  store.dispatch('setVideoID', options.id)
  store.dispatch('setTradingVideoID', options.id)
  return true
}

window.showImage = (a, options) => {
  let params = {
    url: false
  }
  if (!playState(Object.assign(options, params))) {
    return false
  }
  store.dispatch('setPosterUrl', store.getters.liveInfo.overImg)
  store.dispatch('setLiveState', false)
}

window.showLive = (a, options) => {
  let params = {
    url: store.getters.isMobile ? options.url : options.url_flv
  }
  if (!playState(Object.assign(options, params))) {
    return false
  }
  store.dispatch('setLiveState', true)
}

window.showRepeat = (a, options) => {
  let params = {
    url: options.repeat_url
  }
  if (!playState(Object.assign(options, params))) {
    return false
  }
  store.dispatch('setLiveState', false)
}



// WEBPACK FOOTER //
// ./src/views/tv/main.js